(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["set-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(cents, format) {
    format = (format || '{{amount}} TL').replace(/<[^>]*>/g, '');
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var n = Math.round(cents) / 100;
    function d(x, dec, th, dc) {
      var p = x.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p[0] + (p[1] ? dc + p[1] : '');
    }
    if (!m) return d(n, 2, '.', ',');
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = d(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = d(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = d(n, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = d(n, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = d(n, 0, ' ', ','); break;
      case 'amount_with_space_separator': v = d(n, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = d(n, 2, ' ', '.'); break;
      default: v = d(n, 2, ',', '.');
    }
    return format.replace(m[0], v);
  }
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function openDialog(dlg) {
    if (!dlg || dlg.open) return;
    dlg.showModal();
    document.documentElement.classList.add('ssh-lock');
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  // Ortak: ürünleri sepete ekle, varsa indirim kodunu uygula, yönlendir
  function addToCart(root, items, opts) {
    var btn = opts.button, errEl = opts.errorEl, label = btn.dataset.label;
    function showError(msg) { if (errEl) { errEl.textContent = msg || ''; errEl.hidden = !msg; } }
    if (!items.length) { showError('Takıma en az bir ürün ekleyin.'); return; }
    if (root.dataset.props === 'true' && opts.setName) {
      items.forEach(function (it) { it.properties = { 'Takım': opts.setName }; });
    }
    btn.disabled = true;
    btn.textContent = 'Ekleniyor…';
    showError('');
    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
      .then(function () {
        if (opts.discount > 0 && opts.code) {
          return fetch(rootUrl() + 'discount/' + encodeURIComponent(opts.code), { credentials: 'same-origin' }).catch(function () {});
        }
      })
      .then(function () { window.location.href = rootUrl() + (root.dataset.after === 'checkout' ? 'checkout' : 'cart'); })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        showError((err && (err.description || err.message)) || 'Takım sepete eklenemedi. Lütfen tekrar deneyin.');
      });
  }

  // ---- Sepet kampanyası
  var cartSub = 0, campRenderers = [], cartLoaded = false;
  function campCfg(root) {
    if (root.__camp !== undefined) return root.__camp;
    var c = null;
    try { c = JSON.parse(root.dataset.camp || 'null'); } catch (e) {}
    if (c && c.tiers) c.tiers.sort(function (a, b) { return a[0] - b[0]; });
    root.__camp = c && c.on && (c.tiers.length || c.havale > 0) ? c : null;
    return root.__camp;
  }
  function tierDisc(c, base) {
    var d = 0, idx = -1;
    c.tiers.forEach(function (t, i) {
      if (base >= t[0]) { idx = i; d = c.type === 'percent' ? base - Math.round(base * (100 - t[1]) / 10000) * 100 : t[1]; }
    });
    return { d: Math.min(d, base), idx: idx };
  }
  function campCalc(c, amount) {
    var extra = c.cart ? cartSub : 0;
    var withItem = tierDisc(c, extra + amount);
    var without = tierDisc(c, extra);
    var disc = Math.max(0, withItem.d - without.d);
    var final = amount - disc;
    var hav = c.havale > 0 ? final - Math.round(final * c.havale / 100) : final;
    var base = extra + amount;
    var next = c.tiers[withItem.idx + 1] || null;
    return {
      disc: disc, final: final, hav: hav, base: base, next: next,
      pct: c.type === 'percent' && withItem.idx >= 0 ? c.tiers[withItem.idx][1] : 0,
      need: next ? next[0] - base : 0,
      nextLabel: next ? (c.type === 'percent' ? '%' + next[1] : null) : null,
      prevMin: withItem.idx >= 0 ? c.tiers[withItem.idx][0] : 0
    };
  }
  function nextText(c, r, fmt) {
    if (!r.next) return '';
    var val = c.type === 'percent' ? '%' + r.next[1] : money(r.next[1], fmt);
    return 'Sepetinize <strong>' + esc(money(r.need, fmt)) + '</strong> daha eklerseniz <strong>' + esc(val) + '</strong> indirim.';
  }
  function meter(r) {
    if (!r.next) return '';
    var pct = Math.max(4, Math.min(100, Math.round((r.base - r.prevMin) / (r.next[0] - r.prevMin) * 100)));
    return '<div class="ssh-camp-meter" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';
  }
  function saleLabel(r, fmt) { return r.pct ? 'Sepette %' + r.pct : 'Sepette −' + money(r.disc, fmt); }
  function renderSale(root, el, amount) {
    if (!el) return;
    var c = campCfg(root), fmt = root.dataset.moneyFormat;
    var r = c && amount ? campCalc(c, amount) : null;
    if (!r || r.disc <= 0) { el.hidden = true; el.innerHTML = ''; return; }
    el.innerHTML = '<span class="ssh-sale__price">' + esc(money(r.final, fmt)) + '</span><span class="ssh-sale__pill">' + esc(saleLabel(r, fmt)) + '</span>';
    el.hidden = false;
  }
  function renderCamp(root, el, amount) {
    var c = campCfg(root);
    if (!el) return;
    if (!c || !amount) { el.hidden = true; return; }
    var fmt = root.dataset.moneyFormat, r = campCalc(c, amount), mode = el.dataset.sshCamp;
    var hl = esc(c.hl || 'Havale/EFT ile');
    if (mode === 'compact') {
      var parts = [];
      if (c.havale > 0) parts.push('<span class="ssh__camp-item"><span>' + hl + '</span><strong>' + esc(money(r.hav, fmt)) + '</strong></span>');
      el.innerHTML = parts.join('');
      el.hidden = !parts.length;
      return;
    }
    var h = '';
    if (r.disc > 0) {
      h += '<div class="ssh-camp-box__row ssh-camp-box__row--minus"><span>' + esc(c.dl || 'Sepet kampanyası') + '</span><strong>−' + esc(money(r.disc, fmt)) + '</strong></div>';
    }
    if (c.havale > 0) h += '<div class="ssh-camp-box__row' + (r.disc > 0 ? '' : ' ssh-camp-box__row--main') + '"><span>' + hl + '</span><strong>' + esc(money(r.hav, fmt)) + '</strong></div>';
    if (r.next) h += '<p class="ssh-camp-hint">' + nextText(c, r, root.dataset.moneyFormat) + '</p>' + meter(r);
    el.innerHTML = h;
    el.hidden = !h;
  }
  function renderCampBuilder(root, el, amount) {
    var c = campCfg(root);
    if (!el) return;
    if (!c || !amount) { el.hidden = true; return; }
    var fmt = root.dataset.moneyFormat, r = campCalc(c, amount);
    var cells = [];
    if (r.disc > 0) cells.push('<div class="ssh-camp-cell"><span>' + esc(c.dl || 'Sepet indirimi') + '</span><strong class="is-green">−' + esc(money(r.disc, fmt)) + '</strong></div>');
    if (c.havale > 0) cells.push('<div class="ssh-camp-cell"><span>' + esc(c.hl || 'Havale/EFT ile') + '</span><strong>' + esc(money(r.hav, fmt)) + '</strong></div>');
    var h = cells.length ? '<div class="ssh-camp-grid ssh-camp-grid--' + cells.length + '">' + cells.join('') + '</div>' : '';
    if (r.next) h += '<div class="ssh-camp-next"><p class="ssh-camp-hint">' + nextText(c, r, fmt) + '</p>' + meter(r) + '</div>';
    el.innerHTML = h;
    el.hidden = !h;
  }
  function loadCart() {
    if (cartLoaded) return;
    cartLoaded = true;
    fetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartSub = c.items_subtotal_price || 0; campRenderers.forEach(function (f) { f(); }); })
      .catch(function () {});
  }

  function setupReady(card, root) {
    var fmt = root.dataset.moneyFormat;
    var btn = card.querySelector('[data-ssh-ready-add]');
    var opts = card.querySelector('[data-ssh-vopts]');
    var priceEl = card.querySelector('[data-ssh-ready-price]');
    var cmpEl = card.querySelector('[data-ssh-ready-compare]');
    var campEl = card.querySelector('[data-ssh-camp]');
    var saleEl = card.querySelector('[data-ssh-sale]');
    function drawCamp() {
      if (!btn) return;
      var amount = parseInt(btn.dataset.price, 10) || 0;
      renderSale(root, saleEl, amount);
      renderCamp(root, campEl, amount);
    }
    campRenderers.push(drawCamp);
    drawCamp();
    function choose(o) {
      if (!btn) return;
      btn.dataset.variant = o.dataset.value;
      btn.dataset.price = o.dataset.price;
      drawCamp();
      if (priceEl) priceEl.textContent = money(parseInt(o.dataset.price, 10), fmt);
      if (cmpEl) {
        var cp = parseInt(o.dataset.compare, 10) || 0;
        cmpEl.hidden = cp <= parseInt(o.dataset.price, 10);
        cmpEl.textContent = money(cp, fmt);
      }
      var ok = o.dataset.available === 'true';
      btn.disabled = !ok;
      btn.textContent = ok ? btn.dataset.label : 'Tükendi';
      card.dispatchEvent(new CustomEvent('ssh:variant', { bubbles: true }));
    }
    var vars = [];
    try { vars = JSON.parse(card.dataset.sshVariants || '[]'); } catch (e) {}
    var groups = Array.prototype.slice.call(card.querySelectorAll('[data-ssh-ogroup]'));
    function picked() {
      var out = [];
      groups.forEach(function (g) {
        var b = g.querySelector('.ssh__vopt[aria-checked="true"]');
        out[parseInt(g.dataset.sshOgroup, 10)] = b ? b.dataset.val : null;
      });
      return out;
    }
    function markNA() {
      var sel = picked();
      groups.forEach(function (g) {
        var gi = parseInt(g.dataset.sshOgroup, 10);
        g.querySelectorAll('.ssh__vopt').forEach(function (b) {
          var ok = vars.some(function (v) {
            if (!v.a || v.o[gi] !== b.dataset.val) return false;
            return v.o.every(function (x, k) { return k === gi || sel[k] == null || x === sel[k]; });
          });
          b.classList.toggle('is-na', !ok);
        });
      });
    }
    if (groups.length && vars.length) {
      card.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ssh-ogroup] .ssh__vopt');
        if (!b) return;
        var g = b.closest('[data-ssh-ogroup]'), gi = parseInt(g.dataset.sshOgroup, 10);
        g.querySelectorAll('.ssh__vopt').forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
        var sel = picked();
        var v = vars.filter(function (v) { return v.o.every(function (x, k) { return sel[k] == null || x === sel[k]; }); })[0]
             || vars.filter(function (v) { return v.o[gi] === b.dataset.val && v.a; })[0]
             || vars.filter(function (v) { return v.o[gi] === b.dataset.val; })[0];
        if (!v) return;
        groups.forEach(function (gg) {
          var k = parseInt(gg.dataset.sshOgroup, 10);
          gg.querySelectorAll('.ssh__vopt').forEach(function (x) { x.setAttribute('aria-checked', String(x.dataset.val === v.o[k])); });
          var ov = gg.querySelector('[data-ssh-oval]');
          if (ov) ov.textContent = v.o[k];
        });
        choose({ dataset: { value: String(v.id), price: String(v.p), compare: String(v.c), available: String(v.a) } });
        markNA();
      });
      markNA();
    }
    if (opts) opts.addEventListener('click', function (e) {
      var o = e.target.closest('.ssh__vopt');
      if (!o) return;
      opts.querySelectorAll('.ssh__vopt').forEach(function (x) { x.setAttribute('aria-checked', String(x === o)); });
      choose(o);
    });
    if (btn) btn.addEventListener('click', function () {
      addToCart(root, [{ id: parseInt(btn.dataset.variant, 10), quantity: 1 }], {
        button: btn, errorEl: card.querySelector('[data-ssh-error]'), discount: 0, code: '', setName: ''
      });
    });
  }

  function setupSlider(wrap) {
    var track = wrap.querySelector('[data-ssh-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-ssh-slide]'));
    var nav = wrap.parentElement.querySelector('.ssh__slider-nav');
    var prev = nav && nav.querySelector('[data-ssh-prev]');
    var next = nav && nav.querySelector('[data-ssh-next]');
    var dots = nav ? Array.prototype.slice.call(nav.querySelectorAll('[data-ssh-dot]')) : [];
    var counter = nav && nav.querySelector('[data-ssh-counter]');
    var cur = 0, ticking = false;

    function current() {
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
    }
    function paint(i) {
      cur = i;
      dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    function go(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      paint(i);
    }
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; paint(current()); });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    window.addEventListener('resize', function () { go(cur, true); });
    paint(0);
    return { go: go, slides: slides, reset: function () { go(cur, true); } };
  }

  var partsCache = {};
  function loadParts(handle, token) {
    if (partsCache[handle]) return partsCache[handle];
    var q = 'query($h:String!){product(handle:$h){variants(first:100){nodes{id components(first:50){nodes{quantity productVariant{title price{amount} image{url(transform:{maxWidth:200})} product{title handle featuredImage{url(transform:{maxWidth:200})}}}}}}}}}';
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    if (token) headers['X-Shopify-Storefront-Access-Token'] = token;
    partsCache[handle] = fetch('/api/2025-07/graphql.json', {
      method: 'POST', headers: headers, body: JSON.stringify({ query: q, variables: { h: handle } })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        if (j.errors || !j.data || !j.data.product) throw new Error('no data');
        var map = {};
        j.data.product.variants.nodes.forEach(function (v) { map[String(v.id).split('/').pop()] = v.components.nodes; });
        return map;
      })
      .catch(function (e) { delete partsCache[handle]; throw e; });
    return partsCache[handle];
  }

  function setupQuickView(dlg, root) {
    if (dlg.__ssh) return;
    dlg.__ssh = true;
    var fmt = root.dataset.moneyFormat;
    var box = dlg.querySelector('[data-ssh-parts]');
    var list = dlg.querySelector('[data-ssh-parts-list]');
    var countEl = dlg.querySelector('[data-ssh-parts-count]');
    var saveEl = dlg.querySelector('[data-ssh-parts-save]');
    var addBtn = dlg.querySelector('[data-ssh-ready-add]');
    var map = null, failed = false;

    function variantPrice() {
      return (addBtn && parseInt(addBtn.dataset.price, 10)) || (box ? parseInt(box.dataset.price, 10) : 0) || 0;
    }
    function draw() {
      if (!box) return;
      if (failed) {
        if (window.Shopify && Shopify.designMode) {
          list.innerHTML = '<li class="ssh-qv__empty">Editör notu: Takım içeriği alınamadı. Section ayarlarında Storefront erişim anahtarını girin.</li>';
          box.hidden = false;
        } else { box.hidden = true; }
        return;
      }
      if (!map) return;
      var vid = addBtn ? addBtn.dataset.variant : '';
      var comps = map[vid] || [];
      if (!comps.length) { box.hidden = true; return; }
      box.hidden = false;
      var pieces = 0, sum = 0;
      list.innerHTML = comps.map(function (c) {
        var pv = c.productVariant, pr = pv.product;
        var img = (pv.image && pv.image.url) || (pr.featuredImage && pr.featuredImage.url) || '';
        var unit = Math.round(parseFloat(pv.price.amount) * 100);
        pieces += c.quantity; sum += unit * c.quantity;
        var parts = String(pr.title).split(' | ');
        var meta = parts.slice(1);
        if (pv.title && pv.title !== 'Default Title') meta.push(pv.title);
        return '<li class="ssh-qv__part"><span class="ssh-qv__part-img">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
          '<div class="ssh-qv__part-info"><a href="/products/' + encodeURIComponent(pr.handle) + '" target="_blank" rel="noopener">' + esc(parts[0]) + '</a>' +
          (meta.length ? '<span class="ssh-qv__part-meta">' + esc(meta.join(' · ')) + '</span>' : '') + '</div>' +
          '<div class="ssh-qv__part-side"><span class="ssh-qv__part-qty">' + c.quantity + ' adet</span>' +
          '<span class="ssh-qv__part-price">' + esc(money(unit, fmt)) + (c.quantity > 1 ? ' / adet' : '') + '</span></div></li>';
      }).join('');
      if (countEl) countEl.textContent = pieces + ' parça';
      var price = variantPrice();
      if (saveEl) {
        if (root.dataset.saving === 'true' && sum > price && price > 0) {
          saveEl.textContent = 'Parçaları ayrı ayrı alsaydınız ' + money(sum, fmt) + ' ödeyecektiniz. Takımda ' + money(sum - price, fmt) + ' avantaj.';
          saveEl.hidden = false;
        } else saveEl.hidden = true;
      }
    }
    function load() {
      if (map || !box) { draw(); return; }
      loadParts(dlg.dataset.handle, root.dataset.sfToken)
        .then(function (m) { map = m; failed = false; draw(); })
        .catch(function () { failed = true; draw(); });
    }
    dlg.__load = load;
    dlg.addEventListener('ssh:variant', function () { draw(); });

    // Galeri
    var gt = dlg.querySelector('[data-ssh-gtrack]');
    var thumbs = Array.prototype.slice.call(dlg.querySelectorAll('[data-ssh-gthumb]'));
    var gp = dlg.querySelector('[data-ssh-gnav="-1"]'), gn = dlg.querySelector('[data-ssh-gnav="1"]');
    function gIdx() { return gt ? Math.round(gt.scrollLeft / (gt.clientWidth || 1)) : 0; }
    function gPaint() {
      if (!gt) return;
      var i = gIdx(), last = gt.children.length - 1;
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (gp) gp.disabled = i <= 0;
      if (gn) gn.disabled = i >= last;
    }
    function gGo(i) { if (gt) gt.scrollTo({ left: i * gt.clientWidth, behavior: 'smooth' }); }
    if (gt) gt.addEventListener('scroll', function () { requestAnimationFrame(gPaint); }, { passive: true });

    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-ssh-close]')) { dlg.close(); return; }
      var th = e.target.closest('[data-ssh-gthumb]');
      if (th) { gGo(parseInt(th.dataset.sshGthumb, 10)); return; }
      var nv = e.target.closest('[data-ssh-gnav]');
      if (nv) gGo(gIdx() + parseInt(nv.dataset.sshGnav, 10));
    });
    dlg.addEventListener('close', function () {
      if (!document.querySelector('dialog.ssh-modal[open]')) document.documentElement.classList.remove('ssh-lock');
    });
    dlg.__open = function () { openDialog(dlg); if (gt) gt.scrollLeft = 0; gPaint(); load(); };
  }

  function setupBuilder(dlg, root) {
    if (dlg.__ssh) return;
    dlg.__ssh = true;

    var fmt = root.dataset.moneyFormat;
    var pct = parseInt(dlg.dataset.discount, 10) || 0;
    var addBtn = dlg.querySelector('[data-ssh-add]');
    var errEl = dlg.querySelector('[data-ssh-error]');
    var totalEl = dlg.querySelector('[data-ssh-total]');
    var compareEl = dlg.querySelector('[data-ssh-compare]');
    var countEl = dlg.querySelector('[data-ssh-count]');
    var campBar = dlg.querySelector('[data-ssh-camp-builder]');
    var pillEl = dlg.querySelector('[data-ssh-total-pill]');
    var listEl = dlg.querySelector('[data-ssh-total-list]');
    var lastFinal = 0;
    // Toplam: sepet kampanyası varsa indirimli tutar büyük ve yeşil, normal tutar altında küçük
    function drawTotal() {
      var c = campCfg(root);
      var r = c && lastFinal ? campCalc(c, lastFinal) : null;
      var sale = !!(r && r.disc > 0);
      if (totalEl) {
        totalEl.textContent = money(sale ? r.final : lastFinal, fmt);
        totalEl.classList.toggle('is-sale', sale);
      }
      if (pillEl) { pillEl.textContent = sale ? saleLabel(r, fmt) : ''; pillEl.hidden = !sale; }
      if (listEl) { listEl.textContent = sale ? money(lastFinal, fmt) : ''; listEl.hidden = !sale; }
      renderCampBuilder(root, campBar, lastFinal);
    }
    campRenderers.push(drawTotal);

    var rows = Array.prototype.slice.call(dlg.querySelectorAll('[data-ssh-row]')).map(function (el) {
      var prods = [];
      try { prods = JSON.parse(el.dataset.products || '[]'); } catch (e) {}
      var start = 0;
      for (var i = 0; i < prods.length; i++) { if (prods[i].v.some(function (v) { return v.a; })) { start = i; break; } }
      return {
        el: el,
        prods: prods,
        idx: start,
        cb: el.querySelector('.ssh-item__check input'),
        priceEl: el.querySelector('[data-ssh-row-price]'),
        qtyEl: el.querySelector('[data-ssh-qty-val]'),
        stockEl: el.querySelector('.ssh-item__stock'),
        sel: el.querySelector('[data-ssh-var]'),
        img: el.querySelector('[data-ssh-img]'),
        link: el.querySelector('[data-ssh-link]'),
        change: el.querySelector('[data-ssh-change]'),
        picker: el.querySelector('[data-ssh-picker]'),
        modelCount: el.querySelector('[data-ssh-model-count]'),
        required: el.dataset.required === 'true',
        qty: parseInt(el.dataset.qty, 10) || 1,
        shownIdx: -1, variant: null, wantTitle: null
      };
    });

    function minPrice(p) {
      var av = p.v.filter(function (v) { return v.a; });
      var list = av.length ? av : p.v;
      return Math.min.apply(null, list.map(function (v) { return v.p; }));
    }

    function pickerNav(r) {
      var t = r.pickerTrack;
      if (!t) return;
      var p = r.picker.querySelector('[data-ssh-pnav="-1"]'), n = r.picker.querySelector('[data-ssh-pnav="1"]');
      if (p) p.disabled = t.scrollLeft <= 2;
      if (n) n.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
    }
    function buildPicker(r) {
      if (!r.picker || r.picker.__built) return;
      r.picker.__built = true;
      r.pickerTrack = r.picker.querySelector('[data-ssh-picker-track]');
      r.pickerTrack.addEventListener('scroll', function () { pickerNav(r); }, { passive: true });
      r.pickerTrack.addEventListener('wheel', function (e) {
        var t = r.pickerTrack;
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX) && t.scrollWidth > t.clientWidth) {
          var atStart = t.scrollLeft <= 0 && e.deltaY < 0;
          var atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 1 && e.deltaY > 0;
          if (!atStart && !atEnd) { e.preventDefault(); t.scrollLeft += e.deltaY; }
        }
      }, { passive: false });
      r.pickerTrack.innerHTML = r.prods.map(function (p, i) {
        var avail = p.v.some(function (v) { return v.a; });
        return '<button type="button" class="ssh-pick" data-ssh-pick="' + i + '" aria-pressed="' + (i === r.idx) + '"' + (avail ? '' : ' disabled') + '>' +
          (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="120" height="120">' : '') +
          '<span class="ssh-pick__t">' + esc(p.t) + '</span>' +
          '<span class="ssh-pick__p">' + (avail ? esc(money(minPrice(p), fmt)) : 'Tükendi') + '</span></button>';
      }).join('');
    }

    function render(r) {
      var p = r.prods[r.idx];
      if (!p) return null;
      if (r.shownIdx !== r.idx) {
        r.shownIdx = r.idx;
        if (r.link) { r.link.textContent = p.t; r.link.href = p.u; }
        if (r.sel) {
          r.sel.innerHTML = '';
          p.v.forEach(function (x) {
            var o = document.createElement('option');
            o.value = x.id;
            o.textContent = x.t + (x.a ? '' : ' · tükendi');
            r.sel.appendChild(o);
          });
          r.sel.hidden = p.v.length < 2;
          var v0 = null;
          if (r.wantTitle) v0 = p.v.filter(function (x) { return x.t === r.wantTitle && x.a; })[0];
          if (!v0) v0 = p.v.filter(function (x) { return x.a; })[0] || p.v[0];
          if (v0) r.sel.value = String(v0.id);
        }
        if (r.pickerTrack) r.pickerTrack.querySelectorAll('[data-ssh-pick]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(parseInt(b.dataset.sshPick, 10) === r.idx));
        });
      }
      if (r.sel && p.v.length) {
        var id = parseInt(r.sel.value, 10);
        return p.v.filter(function (x) { return x.id === id; })[0] || p.v[0];
      }
      return p.v[0] || null;
    }

    function update() {
      var sum = 0, count = 0;
      rows.forEach(function (r) {
        var v = render(r);
        r.variant = v;
        if (r.img) {
          var cp = r.prods[r.idx];
          var src = (v && v.i) || (cp && cp.i) || '';
          if (r.img.dataset.src !== src) {
            r.img.dataset.src = src;
            if (src) { r.img.src = src; r.img.hidden = false; } else { r.img.hidden = true; }
          }
        }
        var on = r.required || (r.cb && r.cb.checked);
        var unavailable = !v || !v.a;
        var line = v ? v.p * r.qty : 0;
        r.el.classList.toggle('is-off', !on);
        r.el.classList.toggle('is-unavailable', unavailable);
        if (r.stockEl) r.stockEl.hidden = !unavailable;
        if (r.qtyEl) r.qtyEl.textContent = r.qty;
        if (r.priceEl) r.priceEl.textContent = money(line, fmt);
        if (r.modelCount) r.modelCount.textContent = r.prods.length > 1 ? '· ' + r.prods.length + ' model' : '';
        if (r.change) r.change.hidden = r.prods.length < 2;
        if (on && v) { sum += line; count += r.qty; }
      });
      var final = pct > 0 ? Math.round(sum * (100 - pct) / 100) : sum;
      if (compareEl) { compareEl.textContent = money(sum, fmt); compareEl.hidden = sum === 0; }
      if (countEl) countEl.textContent = count ? '· ' + count + ' ürün' : '';
      if (addBtn) addBtn.disabled = count === 0;
      lastFinal = final;
      drawTotal();
    }

    dlg.addEventListener('change', function (e) {
      var row = rows.filter(function (r) { return r.el.contains(e.target); })[0];
      if (row && e.target === row.sel) {
        var v = row.prods[row.idx].v.filter(function (x) { return String(x.id) === row.sel.value; })[0];
        if (v) row.wantTitle = v.t;
      }
      if (errEl) errEl.hidden = true;
      update();
    });

    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-ssh-close]')) { dlg.close(); return; }
      var row = rows.filter(function (r) { return r.el.contains(e.target); })[0];
      if (!row) return;

      var ch = e.target.closest('[data-ssh-change]');
      if (ch) {
        buildPicker(row);
        var open = row.picker.hidden;
        row.picker.hidden = !open;
        ch.setAttribute('aria-expanded', String(open));
        if (open) {
          var cur = row.pickerTrack.querySelector('[aria-pressed="true"]');
          if (cur) row.pickerTrack.scrollLeft = Math.max(0, cur.offsetLeft - 16);
          pickerNav(row);
          var body = dlg.querySelector('.ssh-modal__body');
          var rb = row.el.getBoundingClientRect(), bb = body.getBoundingClientRect();
          if (rb.bottom > bb.bottom) body.scrollBy({ top: rb.bottom - bb.bottom + 12, behavior: 'smooth' });
        }
        return;
      }
      var pn = e.target.closest('[data-ssh-pnav]');
      if (pn) {
        row.pickerTrack.scrollBy({ left: parseInt(pn.dataset.sshPnav, 10) * row.pickerTrack.clientWidth * 0.8, behavior: 'smooth' });
        return;
      }
      var pk = e.target.closest('[data-ssh-pick]');
      if (pk && !pk.disabled) {
        row.idx = parseInt(pk.dataset.sshPick, 10);
        if (row.cb && !row.cb.checked) row.cb.checked = true;
        row.picker.hidden = true;
        if (row.change) row.change.setAttribute('aria-expanded', 'false');
        update();
        return;
      }
      var q = e.target.closest('[data-ssh-qty]');
      if (q) {
        row.qty = Math.min(20, Math.max(1, row.qty + parseInt(q.dataset.sshQty, 10)));
        if (row.cb && !row.cb.checked) row.cb.checked = true;
        update();
      }
    });

    dlg.addEventListener('close', function () {
      if (!document.querySelector('dialog.ssh-modal[open]')) document.documentElement.classList.remove('ssh-lock');
    });

    if (addBtn) addBtn.addEventListener('click', function () {
      update();
      var items = [], problems = [];
      rows.forEach(function (r) {
        var on = r.required || (r.cb && r.cb.checked);
        if (!on) return;
        if (!r.variant || !r.variant.a) { problems.push(r.prods[r.idx] ? r.prods[r.idx].t : 'Ürün'); return; }
        items.push({ id: r.variant.id, quantity: r.qty });
      });
      if (problems.length) {
        errEl.textContent = 'Stokta olmayan seçim var: ' + problems.join(', ') + '. Değiştir ile başka model seçebilirsiniz.';
        errEl.hidden = false;
        return;
      }
      addToCart(root, items, { button: addBtn, errorEl: errEl, discount: pct, code: dlg.dataset.code, setName: dlg.dataset.setName });
    });

    update();
  }

  function adoptThemeFont(root) {
    if (root.dataset.font !== 'theme') return;
    var probe = document.createElement('h2');
    probe.className = 'h2';
    probe.textContent = 'Aa';
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;margin:0';
    root.appendChild(probe);
    var cs = getComputedStyle(probe);
    root.style.setProperty('--ssh-hf', cs.fontFamily);
    root.style.setProperty('--ssh-hw', cs.fontWeight);
    root.removeChild(probe);
    root.classList.add('ssh--hf');
  }

  function init(root) {
    if (root.__ssh) return;
    root.__ssh = true;
    adoptThemeFont(root);
    if (campCfg(root) && campCfg(root).cart) loadCart();

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ssh-tab]'));
    var tabBar = root.querySelector('.ssh__tabs');
    function tabEnd() {
      if (!tabBar) return;
      tabBar.classList.toggle('is-end', tabBar.scrollLeft + tabBar.clientWidth >= tabBar.scrollWidth - 4);
    }
    function revealTab(t) {
      if (!tabBar || tabBar.scrollWidth <= tabBar.clientWidth) return;
      var l = t.offsetLeft, r = l + t.offsetWidth;
      if (l < tabBar.scrollLeft + 16) tabBar.scrollTo({ left: Math.max(0, l - 16), behavior: 'smooth' });
      else if (r > tabBar.scrollLeft + tabBar.clientWidth - 16) tabBar.scrollTo({ left: r - tabBar.clientWidth + 40, behavior: 'smooth' });
    }
    if (tabBar) {
      tabBar.addEventListener('scroll', tabEnd, { passive: true });
      window.addEventListener('resize', tabEnd);
      tabEnd();
    }
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ssh-panel]'));

    function closeHotspots(except) {
      root.querySelectorAll('.ssh__hs.is-open').forEach(function (h) {
        if (h === except) return;
        h.classList.remove('is-open');
        var b = h.querySelector('[data-ssh-hs-btn]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    function activate(i, focus, fromUser) {
      i = String(i);
      tabs.forEach(function (t) {
        var on = t.dataset.sshTab === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus({ preventScroll: true });
        if (on) revealTab(t);
      });
      panels.forEach(function (p) {
        p.hidden = p.dataset.sshPanel !== i;
        if (!p.hidden) { var w = p.querySelector('[data-ssh-slider]'); if (w && w.__slider) w.__slider.reset(); }
      });
      closeHotspots();
      if (fromUser) {
        var panel = panels.filter(function (p) { return p.dataset.sshPanel === i; })[0];
        if (panel && panel.dataset.anchor && window.history && history.replaceState) history.replaceState(null, '', '#' + panel.dataset.anchor);
      }
    }

    tabs.forEach(function (t, idx) {
      t.addEventListener('click', function () { activate(t.dataset.sshTab, false, true); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (idx + 1) % tabs.length;
        if (e.key === 'ArrowLeft') n = (idx - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); activate(tabs[n].dataset.sshTab, true, true); }
      });
    });

    function fromHash() {
      var h = decodeURIComponent((location.hash || '').slice(1));
      if (!h) return;
      var p = panels.filter(function (x) { return x.dataset.anchor && x.dataset.anchor === h; })[0];
      if (p) activate(p.dataset.sshPanel, false, false);
    }
    fromHash();
    window.addEventListener('hashchange', fromHash);

    root.addEventListener('click', function (e) {
      var hb = e.target.closest('[data-ssh-hs-btn]');
      if (hb) {
        var hs = hb.closest('.ssh__hs');
        var open = !hs.classList.contains('is-open');
        closeHotspots(hs);
        hs.classList.toggle('is-open', open);
        hb.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (!e.target.closest('.ssh__hs-pop')) closeHotspots();
      var qb = e.target.closest('[data-ssh-qv]');
      if (qb) { var qd = document.getElementById('ssh-qv-' + qb.dataset.sshQv); if (qd && qd.__open) qd.__open(); return; }
      var ob = e.target.closest('[data-ssh-open]');
      if (ob) openDialog(document.getElementById('ssh-dlg-' + ob.dataset.sshOpen));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeHotspots(); });

    root.querySelectorAll('[data-ssh-ready]').forEach(function (c) { setupReady(c, root); });
    root.querySelectorAll('[data-ssh-qv-dialog]').forEach(function (d) { setupQuickView(d, root); });
    var sliders = Array.prototype.slice.call(root.querySelectorAll('[data-ssh-slider]')).map(function (w) { var sl = setupSlider(w); if (sl) w.__slider = sl; return sl; });
    root.querySelectorAll('[data-ssh-builder]').forEach(function (d) { setupBuilder(d, root); });

    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      var panel = e.target.closest('[data-ssh-panel]');
      if (panel) activate(panel.dataset.sshPanel, false, false);
      var hs = e.target.closest('.ssh__hs');
      if (hs) { closeHotspots(hs); hs.classList.add('is-open'); }
      var slide = e.target.closest('[data-ssh-slide]');
      if (slide) {
        var w = slide.closest('[data-ssh-slider]');
        if (w && w.__slider) setTimeout(function () { w.__slider.go(w.__slider.slides.indexOf(slide), true); }, 30);
      }
      var dlg = e.target.closest('dialog.ssh-modal');
      if (dlg) openDialog(dlg);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (!root.contains(e.target)) return;
      var dlg = e.target.closest('dialog.ssh-modal');
      if (dlg && dlg.open) dlg.close();
    });
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-ssh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["somass-takim-kombin"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('somass-takim-kombin')) return;

    function formatMoney(cents) {
      var fmt = window.theme && theme.settings && theme.settings.money_with_currency_format;
      if (!fmt) return ((parseInt(cents, 10) || 0) / 100).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
      if (typeof cents === 'string') cents = cents.replace('.', '');
      cents = parseInt(cents, 10) || 0;
      function fmtNum(n, dec, th, ds) {
        th = th || '.'; ds = ds || ',';
        var fixed = (n / 100).toFixed(dec);
        var parts = fixed.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
        return whole + (parts[1] ? ds + parts[1] : '');
      }
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
        switch (key) {
          case 'amount': return fmtNum(cents, 2, ',', '.');
          case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
          case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
          default: return fmtNum(cents, 2, '.', ',');
        }
      });
    }

    class SomassTakimKombin extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this.addedText = this.dataset.addedText || 'Sepete eklendi';

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));

        this.querySelectorAll('[data-sml-panel]').forEach((p) => this.updateSummary(p));

        if (window.Shopify && Shopify.designMode) {
          this._onBlockSelect = (e) => {
            var btn = this.querySelector('[data-block-id="' + (e.detail && e.detail.blockId) + '"]');
            if (btn) this.showLook(parseInt(btn.dataset.smlTab, 10));
          };
          document.addEventListener('shopify:block:select', this._onBlockSelect);
        }
      }

      disconnectedCallback() {
        if (this._onBlockSelect) document.removeEventListener('shopify:block:select', this._onBlockSelect);
      }

      onClick(e) {
        var tab = e.target.closest('[data-sml-tab]');
        if (tab) { this.showLook(parseInt(tab.dataset.smlTab, 10)); return; }

        var qtyBtn = e.target.closest('[data-sml-qty]');
        if (qtyBtn) {
          e.preventDefault();
          if (qtyBtn.disabled) return;
          this.changeQty(qtyBtn.closest('[data-sml-item]'), parseInt(qtyBtn.dataset.smlQty, 10));
          return;
        }

        var addOne = e.target.closest('[data-sml-add-one]');
        if (addOne) {
          e.preventDefault();
          if (addOne.disabled) return;
          var item = addOne.closest('[data-sml-item]');
          var q = parseInt(item.dataset.qty, 10) || 1;
          this.addToCart([{ id: parseInt(item.dataset.variantId, 10), quantity: q }], addOne, item.closest('[data-sml-panel]'));
          return;
        }

        var addAll = e.target.closest('[data-sml-add-all]');
        if (addAll) {
          e.preventDefault();
          if (addAll.disabled) return;
          var panel = addAll.closest('[data-sml-panel]');
          var items = [];
          panel.querySelectorAll('[data-sml-item]').forEach((it) => {
            var qty = parseInt(it.dataset.qty, 10) || 0;
            if (qty > 0 && it.dataset.available === 'true') items.push({ id: parseInt(it.dataset.variantId, 10), quantity: qty });
          });
          if (items.length) this.addToCart(items, addAll, panel);
        }
      }

      onChange(e) {
        var sel = e.target.closest('[data-sml-variant]');
        if (sel) this.changeVariant(sel.closest('[data-sml-item]'), parseInt(sel.value, 10));
      }

      showLook(index) {
        this.querySelectorAll('[data-sml-tab]').forEach((b) => {
          var on = parseInt(b.dataset.smlTab, 10) === index;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on && b.scrollIntoView && b.parentElement.scrollWidth > b.parentElement.clientWidth) {
            b.parentElement.scrollTo({ left: b.offsetLeft - 15, behavior: 'smooth' });
          }
        });
        this.querySelectorAll('[data-sml-media]').forEach((m) => {
          m.classList.toggle('is-active', parseInt(m.dataset.smlMedia, 10) === index);
        });
        this.querySelectorAll('[data-sml-panel]').forEach((p) => {
          var on = parseInt(p.dataset.smlPanel, 10) === index;
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
      }

      changeQty(item, delta) {
        if (!item) return;
        var qty = (parseInt(item.dataset.qty, 10) || 0) + delta;
        qty = Math.max(0, Math.min(99, qty));
        this.setQty(item, qty);
      }

      setQty(item, qty) {
        var available = item.dataset.available === 'true';
        if (!available) qty = 0;
        item.dataset.qty = String(qty);
        var val = item.querySelector('[data-sml-qty-val]');
        if (val) val.textContent = qty;
        var minus = item.querySelector('[data-sml-qty="-1"]');
        var plus = item.querySelector('[data-sml-qty="1"]');
        if (minus) minus.disabled = qty <= 0;
        if (plus) plus.disabled = !available || qty >= 99;
        var addOne = item.querySelector('[data-sml-add-one]');
        if (addOne) addOne.disabled = !available || qty <= 0;
        item.classList.toggle('is-off', qty <= 0);
        this.updateSummary(item.closest('[data-sml-panel]'));
      }

      changeVariant(item, variantId) {
        if (!item) return;
        var json = item.querySelector('[data-sml-variants]');
        if (!json) return;
        var variants;
        try { variants = JSON.parse(json.textContent); } catch (err) { return; }
        var v = variants.find((x) => x.id === variantId);
        if (!v) return;

        item.dataset.variantId = v.id;
        item.dataset.price = v.price;
        item.dataset.compare = v.compare || 0;
        item.dataset.available = v.available ? 'true' : 'false';
        item.classList.toggle('is-soldout', !v.available);

        // Fiyat: varyanta ait, temanın "Sepette" rozetiyle önceden hazırlanmış fiyat bloğu
        var priceEl = item.querySelector('[data-sml-price]');
        var tpl = item.querySelector('template[data-sml-price-for="' + v.id + '"]');
        if (priceEl && tpl) {
          priceEl.innerHTML = tpl.innerHTML;
        } else if (priceEl) {
          {
            var onSale = v.compare && v.compare > v.price;
            priceEl.innerHTML = '<span class="price">' +
              (onSale ? '<del><span class="amount">' + formatMoney(v.compare) + '</span></del>' : '') +
              '<ins><span class="amount' + (onSale ? ' discounted' : '') + '">' + formatMoney(v.price) + '</span></ins></span>';
          }
        }

        if (v.image) {
          var img = item.querySelector('img.sml-item__img');
          if (img) { img.removeAttribute('srcset'); img.src = v.image; }
        }
        if (v.url) item.querySelectorAll('[data-sml-link]').forEach((a) => a.setAttribute('href', v.url));

        var addBtn = item.querySelector('[data-sml-add-one]');
        var label = addBtn && addBtn.querySelector('[data-sml-add-label]');
        if (label) label.textContent = v.available ? (addBtn.dataset.addText || 'Sepete Ekle') : 'Tükendi';

        var qty = parseInt(item.dataset.qty, 10) || 0;
        if (v.available && qty === 0 && item._wasSoldout) qty = 1;
        item._wasSoldout = !v.available;
        this.setQty(item, qty);
      }

      updateSummary(panel) {
        if (!panel) return;
        var count = 0, total = 0, compareTotal = 0;
        panel.querySelectorAll('[data-sml-item]').forEach((it) => {
          var qty = parseInt(it.dataset.qty, 10) || 0;
          if (qty <= 0 || it.dataset.available !== 'true') return;
          var price = parseInt(it.dataset.price, 10) || 0;
          var compare = parseInt(it.dataset.compare, 10) || 0;
          count += qty;
          total += price * qty;
          compareTotal += (compare > price ? compare : price) * qty;
        });
        var c = panel.querySelector('[data-sml-count]');
        var t = panel.querySelector('[data-sml-total]');
        var ct = panel.querySelector('[data-sml-compare-total]');
        var btn = panel.querySelector('[data-sml-add-all]');
        if (c) c.textContent = count;
        if (t) t.textContent = formatMoney(total);
        if (ct) {
          ct.hidden = !(compareTotal > total);
          ct.textContent = compareTotal > total ? formatMoney(compareTotal) : '';
        }
        if (btn) btn.disabled = count === 0;

        // Sepet kampanyası: seçili toplamın girdiği barem (tema sepette-fiyat snippet'inden okunur)
        var pct = this.campPct(total);
        var sf = panel.querySelector('[data-sml-sf]');
        var wrap = panel.querySelector('.sml-summary__total');
        if (sf) {
          var on = pct > 0 && total > 0;
          sf.hidden = !on;
          if (wrap) wrap.classList.toggle('has-sf', on);
          if (on) {
            var sfTotal = Math.round(total * (100 - pct) / 10000) * 100;
            panel.querySelector('[data-sml-sf-total]').textContent = formatMoney(sfTotal);
            panel.querySelector('[data-sml-sf-pct]').textContent = pct;
          }
        }
      }

      campPct(amount) {
        if (!this._tiers) {
          try { this._tiers = JSON.parse(this.dataset.camp || '[]'); } catch (e) { this._tiers = []; }
        }
        var pct = 0;
        this._tiers.forEach((t) => { if (amount >= t[0]) pct = t[1]; });
        return pct;
      }

      getSections() {
        var list = [
          { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
          { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
        ];
        if (document.getElementById('Cart')) list.push({ id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' });
        return list.filter((s) => document.getElementById(s.id));
      }

      showMessage(panel, text, ok) {
        var msg = panel && panel.querySelector('[data-sml-msg]');
        if (!msg) return;
        msg.textContent = text;
        msg.classList.toggle('is-ok', !!ok);
        msg.hidden = !text;
        clearTimeout(msg._t);
        if (text) msg._t = setTimeout(() => { msg.hidden = true; }, 5000);
      }

      addToCart(items, button, panel) {
        var label = button.querySelector('[data-sml-add-label]') || button;
        var original = label.textContent;
        button.classList.add('is-loading');
        button.disabled = true;
        this.showMessage(panel, '');

        var sections = this.getSections();
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var url = (window.theme && theme.routes && theme.routes.cart_add_url) ? theme.routes.cart_add_url + '.js' : root + 'cart/add.js';

        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: items,
            sections: sections.map((s) => s.section).join(','),
            sections_url: window.location.pathname
          })
        })
          .then((res) => res.json().then((data) => ({ ok: res.ok, data: data })))
          .then(({ ok, data }) => {
            if (!ok || data.status) {
              throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
            }
            var parser = new DOMParser();
            sections.forEach((s) => {
              var html = data.sections && data.sections[s.section];
              if (!html) return;
              var host = document.getElementById(s.id);
              var target = host.querySelector(s.selector) || host;
              var source = parser.parseFromString(html, 'text/html').querySelector(s.selector);
              if (source) target.innerHTML = source.innerHTML;
            });

            if (typeof dispatchCustomEvent === 'function') {
              dispatchCustomEvent('cart:item-added', { product: data.items ? data.items[0] : data });
            }

            label.textContent = this.addedText;
            var drawer = document.getElementById('Cart-Drawer');
            if (drawer && typeof drawer.open === 'function') {
              drawer.open();
            } else if (!document.getElementById('Cart')) {
              this.showMessage(panel, this.addedText, true);
            }
          })
          .catch((err) => {
            this.showMessage(panel, err.message || 'Ürün sepete eklenemedi.', false);
          })
          .finally(() => {
            button.classList.remove('is-loading');
            setTimeout(() => {
              label.textContent = original;
              if (button.hasAttribute('data-sml-add-all')) {
                this.updateSummary(panel);
              } else {
                var it = button.closest('[data-sml-item]');
                button.disabled = !(it && it.dataset.available === 'true' && parseInt(it.dataset.qty, 10) > 0);
              }
            }, 1600);
          });
      }
    }

    customElements.define('somass-takim-kombin', SomassTakimKombin);
  })();

  } catch(e) { console.error(e); }
})();
})();
